import { Button } from "../../utils/Button";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { BoardManager } from "./BoardManger";
import { HintsButtonContainer } from "./HintsButtonContainer";
import { BoardScene } from "./BoardScene";
import { AudioManager } from "../../AudioManager";

export class GUI extends Phaser.GameObjects.Container {

    private menuButton: Button;
    private infoButton: Button;
    private hintButtonContainer: HintsButtonContainer;
    private menuButtonDeactivated: boolean;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scaleX = GameVars.scaleX;

        this.menuButton = new Button(this.scene, (-GameConstants.GAME_WIDTH / 2 + 65) / GameVars.scaleX, 0, "texture_atlas_1", "btn_menu_off", "btn_menu_on");
        this.menuButton.setOrigin(.5, 0);
        this.menuButton.onDown(this.onClickMenuButton, this);
        this.add(this.menuButton);

        this.infoButton = new Button(this.scene, (-GameConstants.GAME_WIDTH / 2 + 30) / GameVars.scaleX, GameConstants.GAME_HEIGHT - 30, "texture_atlas_1", "btn_info", "btn_info");
        this.infoButton.onDown(this.onClickInfo, this);
        this.add(this.infoButton);

        if (GameVars.gameData.firstSession) {
            this.scene.tweens.add({
                targets: this.infoButton,
                scaleX: 1.15,
                scaleY: 1.15,
                duration: 400,
                yoyo: true,
                repeat: -1
            });
        }

        this.hintButtonContainer = new HintsButtonContainer(this.scene);
        this.add(this.hintButtonContainer);

        if (GameConstants.DEVELOPMENT || GameVars.secretMode) {

            const logBoardButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 75 * GameVars.scaleX, 50, "texture_atlas_1", "btn_log_off", "btn_log_on");
            logBoardButton.onDown(this.onClickLogBoard, this);
            logBoardButton.setScale(.5);
            this.add(logBoardButton);

            const forceLevelOverButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 25 * GameVars.scaleX, 50, "texture_atlas_1", "btn_menu_off", "btn_menu_on");
            forceLevelOverButton.onDown(this.onClickForceLevelOver, this);
            forceLevelOverButton.setScale(.5);
            this.add(forceLevelOverButton);
        } 
    }

    public update(): void {

        this.menuButton.visible = !GameVars.paused;
    }

    public startGame(): void {

        if (!GameVars.levelReset) {

            this.infoButton.alpha = 0;
            
            this.scene.tweens.add({
                targets: this.infoButton,
                alpha: 1,
                duration: 1000,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.menuButton.y = -125;
            this.hintButtonContainer.y = -125;

            this.scene.tweens.add({
                targets: [this.menuButton, this.hintButtonContainer],
                y: 0,
                duration: 1000,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }

        this.hintButtonContainer.startGame();
    }

    public onMatch(): void {   
        
        this.hintButtonContainer.onMatch();
    }

    public onBoardCleared(): void {
        
        this.scene.tweens.add({
            targets: [this.hintButtonContainer, this.infoButton, this.menuButton],
            alpha: 0,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    public onHint(): void {

        if (GameVars.paused) {
            return;
        }

        this.hintButtonContainer.onHint();
    }

    private onClickMenuButton(): void {

        if (GameVars.paused || this.menuButtonDeactivated) {
            return;
        }

        BoardManager.pauseResumeGame();

        AudioManager.playSound("btn_press");
    }

    private onClickInfo(): void {

        if (GameVars.paused || BoardScene.currentInstance.infoLayer) {
            return;
        }

        if (GameVars.gameData.firstSession) {
            this.scene.tweens.killTweensOf(this.infoButton);
            this.infoButton.setScale(1);
        }

        BoardManager.showInfo();

        AudioManager.playSound("btn_press");
    }

    private onClickForceLevelOver(): void {

        BoardManager.onBoardCleared();
    }

    private onClickLogBoard(): void {
            
        console.log(JSON.stringify(GameVars.mahjongEngine.boardData));
    }
}
